module.exports = __webpack_public_path__ + "img/feedback4-2.c7801f17.jpg";